export const styles = {
  dialog: {
    "& .MuiDialogContent-root, .MuiDialogTitle-root, .MuiDialogActions-root": {
      padding: 0,
    },
    width: "100vw",
    height: "100vh",
  },
  title: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    marginBottom: "12px",

    "& > h2": {
      fontWeight: "700",
      fontSize: "22px",
      lineHeight: "26px",
      fontFamily: `"Inter", "Inter", "sans-serif"`,
    },
  },
  closeButtonWrapper: {
    marginBottom: "10px",
  },
  closeButton: {
    width: "24px",
    height: "24px",
    minWidth: "24px",
    minHeight: "24px",
  },
  titleIcon: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    marginBottom: "12px",
    width: "32px",
    height: "32px",
  },
  body: {
    textAlign: "center",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "22px",
    fontFamily: `"Inter", "Inter", "sans-serif"`,
    margin: 0,
  },
  content: {
    padding: "24px",
  },
  cta: {
    background: "#EE4360",
    border: "1px solid #EE4360",
    borderRadius: "16px",
    padding: "14px 0",
    width: "150px",
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "20px",
    textTransform: "initial" as const,
    "&:hover": {
      background: "#FFFFFF",
      border: "1px solid #EE4360",
      color: "#EE4360",
    },
  },
  secondary: {
    borderRadius: "16px",
    border: "1px solid black",
    padding: "14px 0",
    width: "150px",
    fontWeight: "bold" as const,
    fontSize: "16px",
    lineHeight: "20px",
    textTransform: "initial" as const,
  },
};
